// extracted by mini-css-extract-plugin
export default {"numpad":"numpad_numpad__qVgyy","numpadButton":"numpad_numpadButton__9JDY+","presets":"numpad_presets__mtP36","presetButton":"numpad_presetButton__jP+SJ"};